import React, { useContext, useEffect, useState } from "react";
import "./index.scss";
import {
  splitFileName,
  getFileNameFromUrl,
  getFileExtensionFromUrl,
  checkForUserLimit,
} from "../../../utils";
import {
  TICKET_STAGES,
  USER_LIMITS,
  USER_ROLES,
} from "../../../utils/constants";
import { Typography, Divider, Box, Button, IconButton } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArticleIcon from "@mui/icons-material/Article";
import DescriptionIcon from "@mui/icons-material/Description";
import { FileUploader } from "react-drag-drop-files";
import { invokeUploadFile } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import moment from "moment";
import AppContext from "../../../utils/context";
const fileTypes = [
  "JPG",
  "PNG",
  "GIF",
  "JPEG",
  "PDF",
  "DOC",
  "DOCX",
  "TXT",
  "XLSX",
];
const TicketFiles = ({ timeline = [], ticketDetails, loadData }) => {
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  const [jirAttachments, setJirAttachments] = useState([]);
  const { userDetails = {} } = useContext(AppContext);

  const getIconByFileType = (url) => {
    const extension = getFileExtensionFromUrl(url);

    switch (extension) {
      case "pdf":
        return <PictureAsPdfIcon color="error" />;
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return <ImageIcon color="info" />;
      case "doc":
      case "docx":
      case "txt":
        return <ArticleIcon color="primary" />;
      case "xlsx":
        return (
          <Icon
            icon="vscode-icons:file-type-excel"
            width="1.5rem"
            height="1.5rem"
          />
        );
      default:
        return <DescriptionIcon color="primary" />;
    }
  };

  const handleUpload = () => {
    const formData = new FormData();
    formData.append("upload", file);
    setUploadStatus("Uploading...");

    return invokeUploadFile(
      `${HOSTNAME}${REST_URLS.UPLOAD_FILES}${ticketDetails.id}`,
      formData
    )
      .then((response) => {
        if (response.status === 200) {
          toast.success("Uploaded Successfully");
          setFile(null); // Clear file after successful upload
          setUploadStatus("");
          loadData();
        } else {
          toast.error(
            (response.data && response.data.message) || "Upload Failed"
          );
          setUploadStatus("");
        }
      })
      .catch((err) => {
        setUploadStatus("Upload Failed");
        toast.error("Upload Failed");
      });
  };

  const handleCancel = () => {
    setFile(null); // Clear file selection if user cancels
  };

  const handleChange = (file) => {
    setFile(file);
  };
  useEffect(() => {
    const { jointInspectionReport } = ticketDetails;
    if (ticketDetails?.jointInspectionReport) {
      setJirAttachments([
        ...jointInspectionReport?.documents,
        ...jointInspectionReport?.photos,
        ...jointInspectionReport?.videos,
      ]);
    }
  }, []);

  return (
    <div>
      <div className="t-files">
        {timeline.map((line) => {
          if (line.stage === TICKET_STAGES.ATTACHMENT) {
            let stageDetailsObj = {};

            try {
              stageDetailsObj = JSON.parse(line.stageDetails);
            } catch (err) {}

            return (
              <div className="attachment-container" key={line.createdAt}>
                <a
                  className="file-name"
                  href={splitFileName(stageDetailsObj.url)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {getIconByFileType(stageDetailsObj.url)}

                    {getFileNameFromUrl(stageDetailsObj.url)}
                  </Box>
                  <p
                    style={{
                      color: "#9e9999",
                      fontSize: "12px",
                      fontWeight: 500,
                    }}
                  >
                    added on {moment(line.createdAt).format("DD/MM/YYYY")}
                  </p>
                </a>
              </div>
            );
          }
          return (line.attachments || []).map((attachment) => (
            <Typography key={attachment.name}>{attachment.name}</Typography>
          ));
        })}
        {jirAttachments?.length > 0 &&
          jirAttachments.map((ele, index) => {
            return (
              <div className="attachment-container" key={index + 1}>
                <a
                  className="file-name"
                  href={splitFileName(ele)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {getIconByFileType(ele)}

                    {getFileNameFromUrl(ele)}
                  </Box>
                  <p
                    style={{
                      color: "#9e9999",
                      fontSize: "12px",
                      fontWeight: 500,
                    }}
                  >
                    added on{" "}
                    {moment(
                      ticketDetails?.jointInspectionReport?.createdAt
                    ).format("DD/MM/YYYY")}
                  </p>
                </a>
              </div>
            );
          })}
      </div>
      {!checkForUserLimit(USER_LIMITS.QUALITY_ADMIN, userDetails.limits) &&
        userDetails.role !== USER_ROLES.OEM && (
          <div className="add-attachment-con">
            <p style={{ marginTop: "0px" }}>Add more attachments</p>
            <FileUploader
              handleChange={handleChange}
              name="file"
              types={fileTypes}
              label="Click to upload or drag and drop"
            >
              <div>
                <div className="drag-drop-uploder">
                  <img
                    src={require("../../../resources/icons/Download.png")}
                    alt="upload"
                    width="40px"
                  />
                  <p>
                    <span className="clr-text">Click to upload</span> or drag
                    and drop
                  </p>
                  <p>PNG, JPG, Excel or PDF</p>
                </div>
              </div>
            </FileUploader>
            {file && (
              <div>
                <div
                  style={{
                    marginTop: "16px",
                    display: "flex",
                    justifyContent: "center",
                    width: "80%",
                    alignItems: "center",
                  }}
                >
                  <p style={{ color: "gray" }}>{file?.name}</p>
                  <IconButton onClick={handleUpload} color="primary">
                    <CheckCircleOutlineIcon />
                  </IconButton>
                  <IconButton onClick={handleCancel}>
                    <HighlightOffIcon />
                  </IconButton>
                </div>
              </div>
            )}
          </div>
        )}
    </div>
  );
};

export default TicketFiles;
